import { render, staticRenderFns } from "./TicketHistories.vue?vue&type=template&id=0b96268e&scoped=true&"
import script from "./TicketHistories.vue?vue&type=script&lang=js&"
export * from "./TicketHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96268e",
  null
  
)

export default component.exports